import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { adminAPI } from '../utils/api';

const AdminLogs: React.FC = () => {
    const navigate = useNavigate();
    const { t } = useLanguage();
    const [logs, setLogs] = React.useState<any[]>([]);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        const fetchLogs = async () => {
            try {
                // @ts-ignore - adminAPI might not have getLogs in type definition yet if IDE hasn't updated
                const response = await adminAPI.getLogs();
                // Format time using relative time logic or date string
                const formattedLogs = response.data.map((log: any) => ({
                    ...log,
                    time: new Date(log.time).toLocaleString() // Or use date-fns relative time
                }));
                setLogs(formattedLogs);
            } catch (error) {
                console.error('Failed to fetch logs', error);
            } finally {
                setLoading(false);
            }
        };

        fetchLogs();
    }, []);

    return (
        <div className="container mx-auto py-8 px-4">
            <div className="flex justify-between items-center mb-8">
                <h1 className="text-3xl font-bold bg-gradient-to-r from-indigo-400 to-blue-500 bg-clip-text text-transparent">
                    {t('admin.logs.title')}
                </h1>
                <button
                    onClick={() => navigate('/admin')}
                    className="bg-gray-700 hover:bg-gray-600 text-white px-4 py-2 rounded-lg transition-colors"
                >
                    {t('admin.back_to_dashboard')}
                </button>
            </div>

            <div className="bg-gray-800 rounded-lg border border-gray-700 overflow-hidden font-mono text-sm">
                <div className="p-4 border-b border-gray-700 bg-gray-900/50 flex justify-between items-center">
                    <span className="text-gray-400">{t('admin.logs.stream_title')}</span>
                    <button className="text-blue-400 hover:text-blue-300 text-xs">{t('admin.logs.export')}</button>
                </div>
                <div className="divide-y divide-gray-700">
                    {loading ? (
                        <div className="p-4 text-center text-gray-400">Loading...</div>
                    ) : logs.length === 0 ? (
                        <div className="p-4 text-center text-gray-400">No logs found.</div>
                    ) : (
                        logs.map((log) => (
                            <div key={log.id} className="p-4 hover:bg-gray-700/30 transition-colors flex items-center justify-between">
                                <div className="flex items-center gap-4">
                                    <span className="text-gray-500 w-32">{log.time}</span>
                                    <span className={`font-medium ${log.status === 'Success' ? 'text-green-400' : 'text-red-400'
                                        }`}>[{log.status?.toUpperCase() || 'INFO'}]</span>
                                    <span className="text-white">{log.action}</span>
                                    <span className="text-gray-400">by <span className="text-blue-300">{log.user}</span></span>
                                </div>
                                <span className="text-gray-600">{log.ip}</span>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default AdminLogs;
